import "@/App.css";
import { BrowserRouter, Navigate, Route, Routes, useLocation } from "react-router-dom";
import { ThemeProvider } from "next-themes";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Layout } from "@/components/Layout";
import AuthCallback from "@/pages/AuthCallback";
import Home from "@/pages/Home";
import Editor from "@/pages/Editor";
import Compose from "@/pages/Compose";
import CarEdits from "@/pages/CarEdits";
import HistoryPage from "@/pages/History";
import Connections from "@/pages/Connections";
import Membership from "@/pages/Membership";

const Protected = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-[50vh] grid place-items-center"><div className="h-3 w-3 rounded-full bg-primary pulse-dot" /></div>;
  if (!user) return <Navigate to="/" replace />;
  return children;
};

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/editor" element={<Protected><Editor /></Protected>} />
        <Route path="/editor/:projectId" element={<Protected><Editor /></Protected>} />
        <Route path="/car-edits" element={<Protected><CarEdits /></Protected>} />
        <Route path="/compose" element={<Protected><Compose /></Protected>} />
        <Route path="/compose/:batchId" element={<Protected><Compose /></Protected>} />
        <Route path="/history" element={<Protected><HistoryPage /></Protected>} />
        <Route path="/connections" element={<Protected><Connections /></Protected>} />
        <Route path="/membership" element={<Protected><Membership /></Protected>} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Layout>
  );
}

export default function App() {
  return (
    <ThemeProvider attribute="class" defaultTheme="dark" enableSystem={false}>
      <AuthProvider>
        <BrowserRouter>
          <AppRouter />
          <Toaster position="top-right" richColors />
        </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
  );
}
